// 继续率奖金率
export default {
  data() {
    return {
      payPeriodFull: '',
      list: [],
      indexList: []
    };
  },
  methods: {
    initData(init) {
      const close = this.$notice.loading();
      this.$http({
        url: '/buz/upcommission/queryConfigRetentionCommission',
        type: 'POST',
        data: {
          productCode: this.topItem.productCode,
          isMain: this.tableItem.isMain,
          gradeCode: this.tableItem.gradeCode
        }
      })
        .then(res => {
          if (res.data && res.data.rateItemList) {
            res.data.rateItemList.forEach((item, i) => {
              item.key = 'a' + i;
              item.coefficientItemList.forEach((item2, ii) => {
                item2.key = 'b' + ii;
                const list = JSON.parse(JSON.stringify(this.tableItem.programBaseList));
                list.forEach((item3, iii)=>{
                  item3.key = 'c' + iii;
                  item3.programId = item3.id;
                  item3.coefficient = 0;
                  item2.coefficientValueItemList.forEach(item4 => {
                    if(item3.programId == item4.programId) {
                      item3.coefficient = item4.coefficient;
                    }
                  });
                })
                item2.coefficientValueItemList = list;
              });
            });
            this.list = res.data.rateItemList;
            console.log(this.list);
          } else if (init) {
            this.list = [];
            this.addRow();
          } else {
            this.list = [];
          }
          if(this.over) {
            this.visible = true;
          }
        })
        .finally(() => {
          close();
        });
    }
  }
};
